import {createSelector as selector} from 'reselect'

export function identitySelector<T>() {
  return (source: T) => source
}

export default selector
